import { createContext } from 'react'
import type { ModerationErrorKind } from '../../lib/moderationError'
import type { Notification, NotificationStatus } from '../types'

/** Известный отказ модерации, который карточка объясняет сама. */
export type ModerationIssue = Exclude<ModerationErrorKind, 'other'>

export interface NotificationsUiContextValue {
  open: boolean
  setOpen: (open: boolean) => void
  notifications: Notification[]
  setNotifications: (notifications: Notification[]) => void
  addNotification: (notification: Notification) => void
  removeNotification: (id: number) => void
  /** Mark an actionable request as approved/declined: keeps the card visible with
   *  a status badge (instead of removing it) and persists the outcome across WS
   *  snapshots. */
  resolveNotification: (id: number, status: NotificationStatus) => void
  /** Запомнить, почему заявку нельзя одобрить/отклонить; пока открыто окно — карточка это показывает. */
  moderationIssues: Record<number, ModerationIssue>
  setModerationIssue: (id: number, issue: ModerationIssue) => void
}

export const NotificationsUiContext = createContext<NotificationsUiContextValue | null>(null)
